import { useState } from 'react';
import { ICS2NotificationBody } from 'store/declarations/eu/ics2/ics2-notification';
import IE3Q01Details from './IE3Q01Details';
import NotificationsList from '../components/NotificationsList';

const IE3Q01 = ({ notification }: { notification?: ICS2NotificationBody }) => {
    const [location, setLocation] = useState<'list' | 'details'>('list');

    // Note: A Do Not Load order is notification-only, there is no response to send back to customs.
    return location === 'list' ? (
        <NotificationsList
            code="IE3Q01"
            description="Do Not Load (DNL)"
            severity="danger"
            onSeeDetails={() => setLocation('details')}
        />
    ) : (
        <IE3Q01Details notification={notification} onBack={() => setLocation('list')} />
    );
};

export default IE3Q01;
